import React from "react";
import SIDEPANEL from "../constants/SidepanelContent.ts";
import addComponent from "./AddComponents.tsx";
import { useFlowStore } from "../store/FlowStateStore.ts";

const SidePanel: React.FC<any> = ({ collapsed, toggleCollapsed }) => {
  const { nodes, setNodes } = useFlowStore();

  return (
    <div className={`sidepanel-container ${collapsed ? 'sidepanel-collapsed' : ''}`}>
      <div className="sidepanel-header">
        {!collapsed && <span className="sidepanel-title">Components</span>}
        <button
          type="button"
          className="collapse-toggle"
          onClick={toggleCollapsed}
          title={collapsed ? "Expand panel" : "Collapse panel"}
          aria-label={collapsed ? "Expand panel" : "Collapse panel"}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="7" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <path
              d={collapsed ? "M14 8L18 12L14 16" : "M18 8L14 12L18 16"}
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      <div>
        {Object.entries(SIDEPANEL).map(([section, items]) => (
          <div key={section}>
            {collapsed ? <div className="sidepanel-section-divider" /> : <h2>{section}</h2>}
            <ul className="flex flex-wrap items-center" style={{ justifyContent: "space-around" }}>
              {items.map((item, index) => (
                <li
                  onClick={() => addComponent(item, nodes, setNodes)}
                  key={index}
                  title={collapsed ? item.name : undefined}
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  className={`rounded-[5px] flex flex-col mt-4 py-1 w-[100px] h-[80px] justify-center cursor-pointer sidepanel-item ${item.enabled ? '' : 'disable-panel'}`}
                >
                  {item.icon && <img src={item.icon} alt={item.name} width={20} />}
                  {!collapsed && <div className="text-xs text-center">{item.name}</div>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SidePanel;
